export default __webpack_public_path__ + "NY_404.1b5826c9.png";